import { Pipe, PipeTransform } from '@angular/core';
import {CompetitorTableComponent, CompetitorTableRowData} from "@components";

@Pipe({
  name: 'filterCompetitorTableRowData',
})
export class FilterCompetitorTableRowDataPipe implements PipeTransform {
  transform(fields: (keyof CompetitorTableRowData | string)[]): (keyof CompetitorTableRowData)[] {
    return fields.filter(field => !(field.startsWith(CompetitorTableComponent.CUSTOM_FIELD_COLUMN_PREFIX) || field.startsWith(CompetitorTableComponent.ADDITIONAL_PRICING_ITEM_COLUMN_PREFIX))) as (keyof CompetitorTableRowData)[];
  }
}
